import { gql } from '@apollo/client';

import { CHECK_WARRANTY_STATUS_OPERATION } from 'utils/constants';

export const CHECK_WARRANTY_STATUS = gql`
  query ${CHECK_WARRANTY_STATUS_OPERATION}($accountId: ID, $input: CheckWarrantyStatusInput!, $images: ProductImageLookupFilter) {
    getAccount(accountId: $accountId) {
      accountId
      checkWarrantyStatus(input: $input) {
        customerOracleID
        customerName
        serialNumber
        status
        product {
          id
          partName
          partNumber
          description
          productLine
          outOfWarrantyPrice
          outOfWarrantyEligible
          getImages(input: $images) {
            imageName
            imageAbsoluteUrl
          }
        }
      }
    }
  }
`;
